const en = {
	language: {
		language: 'CN',
	},
	nav: {
		text1: 'Bono Service',
		text2: 'Bono Product',
		text3: 'Provide customization service for diagnostic consumables wholeheartedly',
		text4: 'Fully automatic production line advanced equipment Constantly develop new products',
	},
	info: {
		text1: 'Bono Product',
		text2: 'Product Specifications',
		text3: 'Error',
		text4: 'Product Specifications',
	},
	search: {
		text1: 'Search',
		text2: 'Recommended Search:',
		text3: 'No Data',
		text4: 'Colloidal Gold cassette',
		text5: 'Test Cassette',
		text6: 'Reagent Cassette',
		text7: 'Plastic Cassette',
		text8: 'Pregnancy Midstream',
		text9: 'Multi Cassette',
		text10: 'Filling Production',
		text11: 'Enter your Content',
		text12: 'Click to Cearch',
	},
	footer: {
		text1: 'About',
		text2: 'Bono Plastics (Beijing) Co., Ltd',
		text3: 'Contact: Mrs.Jiang，86-18601366266',
		text4: 'Address: No.2 Science park,Doudian Town, Fangshan District,Beijing,China',
		text5: 'Postcode: 102433',
		text6: 'Tel/Fax: 86-10-69391268',
		text7: 'Email: <a href="mailto:jiangqiong@bonore.com">jiangqiong@bonore.com</a>',
		text8: '<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备11043213号-1</a>',
	},
	index: {
		text1: 'We specialize in providing supporting consumables and comprehensive production services for the in vitro diagnostic reagent industry.',
		text2: 'Established in August 2008, Bono Plastics (Beijing) Co.,Ltd, HQ is located in Fangshan District, Beijing, with two branches in Dingxing, Heibei and Tianjin.',
		text3: 'Click to Enter',
		text4: 'Facility & Environment',
		text5: 'View',
		text6: 'Certifications',
		text7: 'We are certified by IAF and CNAS and other international management system, we aim to provide quality products and be your reliable and dependable partner.',
		text8: 'Dependable Factory / Excellent Products / Sincere Service',
		text9: 'Click to View',
		text10: 'Product Center',
	},
	product: {
		text1: 'Bono Product',
		text2: 'All products',
		text3: 'View',
		text4: 'No Data',
		text5: 'Previous Page',
		text6: 'Next Page',
	},
	news: {
		text1: 'Click to View',
		text2: 'News',
		text3: 'Body',
		text4: 'Error',
	},
	contact: {
		text1: 'Bono Plastics (Beijing) Co., Ltd',
		text2: 'FAQ/ Experts answer/ Questions about facility or product usage',
		text3: 'Contact: Mrs.Jiang',
		text4: 'Contact: 18601366266',
		text5: 'Address: No.2 Science park,Doudian Town, Fangshan District,Beijing,China',
		text6: 'Postcode: 102433',
		text7: 'Contact: 86-10-69391268 / 86-18601366266',
		text8: 'Fax: 86-10-69391268',
		text9: 'Email: <a href="mailto:jiangqiong@bonore.com">jiangqiong@bonore.com</a>',
		text10: 'Online Message',
		text11: 'Years of industry experience.',
		text12: 'First name / Last name: ',
		text13: 'Enter your name',
		text14: 'Phone number: ',
		text15: 'Enter your phone number',
		text16: 'Email: ',
		text17: 'Enter your email',
		text18: 'Message: ',
		text19: 'Enter your messages',
		text20: 'Submit Message',
		text21: 'Submitting...',
		text22: 'Success',
		text23: 'Enter your messages',
		text24: 'Years of industry experience',
		text25: 'Provide 7*24 hours online service, contact us now.',
		text26: 'Contact: 18601366266 Mrs.Jiang',
		text27: 'Please leave your messages, we will contact you shortly',
		text28: 'Please leave your name',
		text29: 'Please leave your phone number',
		text30: 'Please leave your message',
	},
	about: {
		text1: 'We specialize in providing supporting consumables and comprehensive production services for the in vitro diagnostic reagent industry.',
		text2: 'Established in August 2008, Bono Plastics (Beijing) Co.,Ltd, HQ is located in Fangshan District, Beijing, with two branches in Dingxing, Heibei and Tianjin.  We specialize in providing supporting consumables and comprehensive production services for the in vitro diagnostic reagent industry, we have gain excellent reputation in both domestic market and United States, India, Uk, Japan, Chile and some other countries.',
		text3: 'The company owns an advanced automatic production line with electric injection molding machines, featuring 150 injection molding machines, 6 blow molding machines, and 120 filling machines of various types. We are a high-tech enterprise integrating development, design, production, and sales, continuously innovating and developing new products along with the rapid development of the IVD industry.',
		text4: 'Excellent quality, sincere service is our corporate philosophy.To be your reliable partner is always our goal.',
		text5: 'Welcome all customers to visit us!  Looking forward to building a long-term business relationship with you!',
		text6: 'Injection molding machine/ machine',
		text7: 'Blow molding machine/ machine',
		text8: 'Filling machine/ machine',
		text9: 'Enterprise Proverbs',
		text10: 'Perfect Quality; Sincere Service',
		text11: 'Standardized Management; Constantly Innovation',
	},
	honor: {
		text1: 'We can provide: ',
		text2: "Our enterprise's quality management and quality assurance capabilities meet the corresponding standards and are capable of providing products according to the specified quality requirements.",
		text3: 'Class I Medical device production certificate record',
		text4: 'Bono Plastics (Beijing) Co.,Ltd passed the Class I medical device production record certificate and are capable of becoming your reliable partner.',
		text5: 'Dependable Factory',
		text6: 'Excellent Products',
		text7: 'Sincere Service',
		text8: 'Quality management system certification',
		text9: 'GB/T19001-2016/ISO9001:2015',
		text10: "This is to certify the quality management system of Bono Plastics (Beijing) Co., Ltd. conforms to the scope covered by the GB/T19001-2016/ISO9001:2015 standard certification, including the production and sales of plastic packaging products (except those with licensing requirements) and molds.Our enterprise's quality management and quality assurance capabilities meet the corresponding standards and are capable of providing products according to the specified quality requirements.",
		text11: 'Recognized by domestic market',
		text12: 'Recognized by international market',
		text13: 'Quality Management System Certification',
		text14: '·  Approved by China',
		text15: '·  International mutual recognition',
		text16: 'This is to certify the quality management system of Bono Plastics (Beijing) Co., Ltd. conforms to the scope covered by the GB/T19001-2016/ISO9001:2015 standard certification, including the production and sales of plastic packaging products (except those with licensing requirements) and molds.',
		text17: "Our enterprise's quality management and quality assurance capabilities meet the corresponding standards and are capable of providing products according to the specified quality requirements.",
	},
};

export default en